<template lang="html">
  <div class="AboutB">
    <svg id="about-b" viewBox="0 0 218 180" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <!-- Generator: Sketch 55.2 (78181) - https://sketchapp.com -->
        <title>02</title>
        <desc>Created with Sketch.</desc>
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
            <g id="1.618-About" transform="translate(-611.000000, -1717.000000)" stroke="#000">
                <g id="02" transform="translate(612.000000, 1717.000000)">
                    <g id="Group-3" transform="translate(13.000000, 4.000000)">
                        <ellipse id="Oval" cx="56" cy="22.5" rx="22" ry="22.5"></ellipse>
                        <path d="M56,3 C45.5065898,3 37,11.7304474 37,22.5" id="Oval"></path>
                        <path d="M110.264891,66.486467 C99.2778237,68.7766284 91,78.8813406 91,91" id="Oval-Copy-10"></path>
                        <path d="M68.7800153,132.424864 C60.1012318,136.189692 54,145.109415 54,155.513533" id="Oval-Copy-11"></path>
                        <path d="M175,46 C167.820298,46 162,51.8202983 162,59" id="Oval-Copy-8"></path>
                        <path d="M16,102 C8.82029825,102 3,107.820298 3,115" id="Oval-Copy-9"></path>
                        <circle id="Oval-Copy-3" cx="174.5" cy="58.5" r="15.5"></circle>
                        <circle id="Oval-Copy-4" cx="15.5" cy="114.5" r="15.5"></circle>
                        <path d="M108.738138,63 C96.2113417,66.4680415 87,78.1266274 87,91.9749307 C87,108.557319 100.2076,122 116.5,122 C132.7924,122 146,108.557319 146,91.9749307 C146,83.3538679 142.430138,75.5814314 136.712881,70.1054057" id="Path"></path>
                        <path d="M63.9463658,130.083571 C55.0206189,135.224998 49,144.949862 49,156.100122 C49,163.676581 51.4179216,169.730504 56,175 M56,175 L101,175 C105.342969,169.792354 108,163.453159 108,156.100122 C108,143.423826 100.218633,132.589787 89.2336128,128.23824" id="Shape"></path>
                    </g>
                    <path d="M138.095947,152 L159,152" id="Path-112"></path>
                    <path d="M148.095947,141 L156.383789,141" id="Path-112-Copy-8"></path>
                    <path d="M172,141 L174.239868,141" id="Path-112-Copy-9"></path>
                    <path d="M134.962158,0.5 L141.462158,0.5" id="Path-117"></path>
                    <path d="M122.808105,22.5 L140.212158,22.5" id="Path-112-Copy-3"></path>
                    <path d="M156.212158,22.5 L161.212158,22.5" id="Path-112-Copy-4"></path>
                    <path d="M74.9141846,77.5 L84.2651978,77.5" id="Path-112-Copy-7"></path>
                    <path d="M120.5,166 L199.298828,166" id="Path-116"></path>
                    <path d="M31.0361328,166 L62.5,166" id="Path-116-Copy"></path>
                    <path d="M171.765198,22.5 L174.212158,22.5" id="Path-112-Copy-5"></path>
                    <path d="M53.9141846,91.5 L60.0858154,91.5" id="Path-112-Copy"></path>
                    <path d="M38.2121582,91.5 L41.9141846,91.5" id="Path-112-Copy-2"></path>
                    <polygon id="Path-105" points="23 42.2666667 23 39 205.974026 84.08 216 82.12 216 85.3866667 205.974026 88"></polygon>
                    <path d="M206,84 L206,88" id="Path-115"></path>
                    <polyline id="Path-106" points="23 39 38 39 54 43"></polyline>
                    <path d="M75.5060381,48.125257 L176,73" id="Path-107"></path>
                    <path d="M193,77 L216,82" id="Path-108"></path>
                    <polygon id="Path-109" points="0 140 0 136.551724 213 120 213 123.448276"></polygon>
                </g>
            </g>
        </g>
    </svg>
  </div>
</template>

<script>
import Vue from 'vue'
import VueRouter from 'vue-router'
import Vivus from 'vivus'


Vue.use(VueRouter)

export default {
  mounted () {
    new Vivus('about-b', {duration: 120, animTimingFunction: Vivus.EASE_OUT});
  }
}

</script>

<style lang="scss" scoped>
.AboutB {
  max-width: 400px;
  margin: 60px auto 30px;
  // transform: translateX(-8%);
}
</style>



// WEBPACK FOOTER //
// src/components/svgs/AboutB.vue